// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3i72K","alert":"SettungsInbox_alert__1jWIc"};